
import { Component, Input } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { InputTextModule } from 'primeng/inputtext';

@Component({
  selector: "app-text-input",
  templateUrl: "./text-input.component.html",
  styleUrls: ["./text-input.component.scss"],
  standalone: true,
  imports: [
    FormsModule,
    ReactiveFormsModule,
    InputTextModule
],
})
export class TextInputComponent {
  @Input() valueFormControl!: FormControl;
  @Input() placeholderValue = '';
}
